<template>
    <el-card class="main-card">
        <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
            <div style="font-size: 20px; font-weight: bold">产品型号</div>
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="openAddDialog">新增型号</el-button>
        </div>

        <!-- 搜索区域 -->
        <div class="search-bar">
            <el-select v-model="searchField" style="width: 120px">
                <el-option label="型号名称" value="name" />
                <el-option label="型号编码" value="code" />
            </el-select>
            <el-input
                v-model="searchKeyword"
                :placeholder="searchField === 'code' ? '请输入型号编码' : '请输入型号名称'"
                prefix-icon="el-icon-search"
                clearable
                style="width: 220px"
                @keyup.enter.native="handleSearch"
                @clear="handleSearch"
            />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh-right" @click="handleReset">重置</el-button>
        </div>

        <el-table v-loading="tableLoading" :data="productList" border stripe style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="code" label="型号编码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="name" label="型号名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="description" label="型号描述" min-width="200" show-overflow-tooltip />
            <el-table-column label="产品图片" width="100" align="center">
                <template slot-scope="scope">
                    <!-- <div>{{ scope.row.urlHttp }}</div> -->
                    <el-image  fit="cover" style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer"
                        :src="scope.row.urlHttp"
                        :preview-src-list="[scope.row.urlHttp]" />
                </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" width="160" show-overflow-tooltip />
            <el-table-column label="操作" width="150" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="display: flex; justify-content: flex-end; margin-top: 16px">
            <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total"
                :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" :current-page="currentPage"
                @size-change="handleSizeChange" @current-change="handlePageChange" />
        </div>

        <!-- 新增/编辑产品型号弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false"
            @closed="resetForm">
            <el-form ref="formRef" :model="form" :rules="formRules" label-width="100px">
                <el-form-item label="型号编码" prop="code">
                    <el-input v-model="form.code" placeholder="请输入型号编码，如 CAB_STD" maxlength="50" clearable />
                </el-form-item>
                <el-form-item label="型号名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入型号名称" maxlength="50" show-word-limit clearable />
                </el-form-item>
                <el-form-item label="型号描述" prop="description">
                    <el-input v-model="form.description" type="textarea" :rows="3" placeholder="请输入型号描述"
                        maxlength="2000" show-word-limit />
                </el-form-item>
                <el-form-item label="产品图片" prop="urlHttp">
                    <el-upload
                        class="avatar-uploader"
                        action="#"
                        :show-file-list="false"
                        :http-request="handleUpload"
                        accept="image/*">
                        <el-image v-if="form.urlHttp" :src="form.urlHttp " fit="cover" style="width: 120px; height: 120px; border-radius: 6px;" />
                        <i v-else class="el-icon-plus avatar-uploader-icon" />
                    </el-upload>
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="form.sortOrder" :min="0" :max="9999" controls-position="right" />
                </el-form-item>

                <!-- 产品尺寸配置 -->
                <!-- <el-divider content-position="left">产品尺寸配置</el-divider>
                <div v-for="(size, index) in form.productSizeList" :key="index" class="size-item">
                    <div class="size-header">
                        <span>尺寸 {{ index + 1 }}</span>
                        <el-button type="text" size="mini" style="color: #f56c6c" @click="removeSize(index)">删除</el-button>
                    </div>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="尺寸编码" :prop="`productSizeList.${index}.code`" :rules="{ required: true, message: '请输入尺寸编码', trigger: 'blur' }">
                                <el-input v-model="size.code" placeholder="尺寸编码" size="small" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="尺寸名称" :prop="`productSizeList.${index}.name`" :rules="{ required: true, message: '请输入尺寸名称', trigger: 'blur' }">
                                <el-input v-model="size.name" placeholder="尺寸名称" size="small" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item label="长度(mm)" :prop="`productSizeList.${index}.length`" :rules="{ required: true, message: '请输入长度', trigger: 'blur' }">
                                <el-input v-model="size.length" placeholder="长度" size="small" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="宽度(mm)" :prop="`productSizeList.${index}.width`" :rules="{ required: true, message: '请输入宽度', trigger: 'blur' }">
                                <el-input v-model="size.width" placeholder="宽度" size="small" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="高度(mm)" :prop="`productSizeList.${index}.height`" :rules="{ required: true, message: '请输入高度', trigger: 'blur' }">
                                <el-input v-model="size.height" placeholder="高度" size="small" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="内部基础价" :prop="`productSizeList.${index}.basePriceInner`" :rules="{ required: true, message: '请输入内部基础价', trigger: 'blur' }">
                                <el-input v-model="size.basePriceInner" placeholder="内部基础价" size="small" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="外部基础价" :prop="`productSizeList.${index}.basePriceOut`" :rules="{ required: true, message: '请输入外部基础价', trigger: 'blur' }">
                                <el-input v-model="size.basePriceOut" placeholder="外部基础价" size="small" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item label="排序">
                                <el-input-number v-model="size.sortOrder" :min="0" :max="9999" controls-position="right" size="small" style="width: 100%" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="状态">
                                <el-select v-model="size.status" placeholder="请选择状态" size="small" style="width: 100%">
                                    <el-option label="禁用" :value="0" />
                                    <el-option label="启用" :value="1" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-button type="primary" size="small" icon="el-icon-plus" style="width: 100%; margin-top: 10px" @click="addSize">添加尺寸</el-button> -->

            </el-form>
            <div slot="footer" style="display: flex; justify-content: flex-end; gap: 6px">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="handleSubmit">保存</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import { productModelList, productModelDetail, productModelAdd, productModelUpdate, productModelDelete, uploadFile } from '@/api/quote'

export default {
    name: 'QuoteModel',
    data() {
        return {
            productList: [],
            total: 0,
            currentPage: 1,
            pageSize: 10,
            tableLoading: false,
            searchKeyword: '',
            searchField: 'name',
            // 弹窗
            dialogVisible: false,
            dialogTitle: '新增产品型号',
            isEdit: false,
            submitLoading: false,
            form: {
                id: null,
                code: '',
                name: '',
                description: '',
                urlHttp: '',
                uploadFile: null,
                sortOrder: 0,
                // productSizeList: [],
            },
            formRules: {
                code: [{ required: true, message: '请输入型号编码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入型号名称', trigger: 'blur' }],
            },
        }
    },
    created() {
        this.fetchProductList();
    },
    methods: {
        // 获取产品型号列表（分页）
        async fetchProductList() {
            this.tableLoading = true;
            try {
                const filter = []
                if (this.searchKeyword && this.searchKeyword.trim()) {
                    const keyword = this.searchKeyword.trim()
                    if (this.searchField === 'name') {
                        filter.push({
                            name: 'name',
                            value: keyword,
                            type: 'LIKE',
                        })
                    } else if (this.searchField === 'code') {
                        filter.push({
                            name: 'code',
                            value: keyword,
                            type: 'EQ',
                        })
                    }
                }
                const param = {
                    filter,
                    sorted: [{ name: 'sortOrder', type: 'ASC' }],
                    current: this.currentPage ,
                    size: this.pageSize,
                }

                const res = await productModelList(param)
                if (res && res.code === '0000') {
                    this.productList = res.result.records
                    this.total = res.result.total
                }
            } catch (error) {
                console.error('获取产品型号列表失败：', error)
            } finally {
                this.tableLoading = false;
            }
        },

        // 分页大小变化
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.fetchProductList();
        },

        // 页码变化
        handlePageChange(page) {
            this.currentPage = page;
            this.fetchProductList();
        },

        // 搜索
        handleSearch() {
            this.currentPage = 1;
            this.fetchProductList();
        },

        // 重置搜索
        handleReset() {
            this.searchField = 'name';
            this.searchKeyword = '';
            this.currentPage = 1;
            this.fetchProductList();
        },

        // 打开新增弹窗
        openAddDialog() {
            this.isEdit = false;
            this.dialogTitle = '新增产品型号';
            this.dialogVisible = true;
        },

        // 打开编辑弹窗
        async openEditDialog(row) {
            this.isEdit = true;
            this.dialogTitle = '编辑产品型号';
            this.dialogVisible = true;
            try {
                const res = await productModelDetail(row.id);
                if (res && res.code === '0000') {
                    const data = res.result || {};
                    this.form = {
                        id: data.id,
                        code: data.code,
                        name: data.name,
                        description: data.description,
                        urlHttp: data.urlHttp,
                        uploadFile: null,
                        sortOrder: data.sortOrder,
                        // productSizeList: data.productSizeList,
                    };
                }
            } catch (error) {
                console.error('获取产品型号详情失败：', error);
                this.$message.error('获取详情失败');
            }
        },

        // 重置表单
        resetForm() {
            this.form = {
                id: null,
                code: '',
                name: '',
                description: '',
                urlHttp: '',
                uploadFile: null,
                sortOrder: 0,
                // productSizeList: [],
            };
            this.$refs.formRef && this.$refs.formRef.clearValidate();
        },
        // 添加尺寸
        // addSize() {
        //     this.form.productSizeList.push({
        //         code: '',
        //         name: '',
        //         length: '',
        //         width: '',
        //         height: '',
        //         basePriceInner: '',
        //         basePriceOut: '',
        //         sortOrder: 0,
        //         status: 1,
        //     });
        // },
        // // 删除尺寸
        // removeSize(index) {
        //     this.form.productSizeList.splice(index, 1);
        // },

        // 上传图片
        async handleUpload({ file }) {
            const formData = new FormData()
            formData.append('file', file)
            try {
                const res = await uploadFile(formData, 'quote')
                if (res && res.code === '0000') {
                    this.form.uploadFile = res.result
                    this.form.urlHttp = res.result.urlHttp
                    this.$message.success('上传成功')
                } else {
                    this.$message.error(res.message || '上传失败')
                }
            } catch (error) {
                console.error('上传图片失败：', error)
                this.$message.error('上传失败')
            }
        },

        // 提交新增/编辑
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) return;
                this.submitLoading = true;
                try {
                    const param = {
                        code: this.form.code,
                        name: this.form.name,
                        description: this.form.description,
                        sortOrder: this.form.sortOrder,
                        uploadFile: this.form.uploadFile,
                        // productSizeList: this.form.productSizeList,
                        // urlHttp: this.form.urlHttp,
                    }
                    if (this.isEdit) {
                        param.id = this.form.id;
                    }
                    let res;
                    if (this.isEdit) {
                        res = await productModelUpdate(param);
                    } else {
                        res = await productModelAdd(param);
                    }
                    if (res && res.code === '0000') {
                        this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
                        this.fetchProductList();
                        this.dialogVisible = false;
                    } else {
                        this.$message.error(res.message || (this.isEdit ? '编辑失败' : '新增失败'));
                    }
                } catch (error) {
                    console.error(this.isEdit ? '编辑产品型号失败：' : '新增产品型号失败：', error);
                } finally {
                    this.submitLoading = false;
                }
            });
        },

        // 删除
        handleDelete(row) {
            this.$confirm(`确认删除产品型号「${row.name}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(async () => {
                try {
                    const res = await productModelDelete(row.id);
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功');
                        this.fetchProductList();
                    } else {
                        this.$message.error(res.message || '删除失败');
                    }
                } catch (error) {
                    console.error('删除产品型号失败：', error);
                    this.$message.error('删除失败');
                }
            }).catch(() => { });
        },
    }
}
</script>

<style scoped>
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
    overflow: hidden;
    transition: all 0.3s ease;
}

.main-card:hover {
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1890ff;
}

.search-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    border-radius: 8px;
}

.avatar-uploader ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-uploader ::v-deep .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
}

/* .size-item {
    border: 1px solid #ebeef5;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    background-color: #fafafa;
}

.size-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-weight: bold;
    color: #303133;
}

.size-item ::v-deep .el-form-item__label {
    text-align: left;
} */
</style>

<style>
/* 表格单元格溢出提示：限制宽度并允许自动换行，避免超长文本撑成横条 */
.el-tooltip__popper {
    max-width: 480px;
    line-height: 1.6;
    white-space: normal;
    word-break: break-word;
}
</style>